import { AlertProvider } from '@src/components/Alert';
import { isGCashEnv } from '@src/utils/isGCashEnv';
import {
  AccordionGroup,
  CurrenciesProvider,
  CurrencyConversionProvider,
  EndpointsContextProvider,
  GlobalDialogProvider,
  HeartbeatsProvider,
  IntlProvider,
  MarketPriceContextProvider,
  MixpanelProvider,
  NotesProvider,
  RefRateContextProvider,
  SecuritiesProvider,
  SparklineProvider,
  WLCustomerMarketAccountsProvider,
  WLCustomerUserConfigContextProvider,
  WLExposuresProvider,
  WLFavoriteSecuritiesProvider,
  WLHomeCurrencyProvider,
  WLOrdersProvider,
  WLOrgConfigProvider,
  WLTradingLimitsProvider,
  WLUserContextProvider,
  WLUsersContextProvider,
  WLWebSocketClientProvider,
  composeComponents,
} from '@talos/kyoko';
import { StackScreenProvider } from '../components/StackScreen';
import { GCashBalancesProvider } from './GCashBalancesProvider';
import { GCashBalanceTransactionProvider } from './GCashBalanceTransactionProvider';
import { GCashHomeBalanceProvider } from './GCashHomeBalanceContext';
import { GCashOrderFormProvider } from './GCashOrderFormProvider';
import { GCashOrgConfigProvider } from './GCashOrgConfigProvider';
import { GCashQueryProvider } from './GCashQueryProvider';
import { MarketDataProvider } from './MarketDataProvider';
import { ProvidersGate } from './ProvidersGate';

const OrgConfigProvider = isGCashEnv ? GCashOrgConfigProvider : WLOrgConfigProvider;

export const EssentialProviders = composeComponents([
  OrgConfigProvider,
  EndpointsContextProvider,
  MixpanelProvider,
  WLWebSocketClientProvider,
  WLUserContextProvider,
  WLCustomerMarketAccountsProvider,
  IntlProvider,
]);

export const Providers = composeComponents([
  WLCustomerUserConfigContextProvider,
  NotesProvider,
  CurrenciesProvider,
  SecuritiesProvider,
  WLOrdersProvider,
  WLHomeCurrencyProvider,
  WLUsersContextProvider,
  CurrencyConversionProvider,
  WLExposuresProvider,
  WLTradingLimitsProvider,
  GCashBalancesProvider,
  GCashHomeBalanceProvider,
  ProvidersGate,
  GCashQueryProvider,
  GCashBalanceTransactionProvider,

  GlobalDialogProvider,
  WLFavoriteSecuritiesProvider,
  RefRateContextProvider,
  MarketPriceContextProvider,
  AccordionGroup,
  HeartbeatsProvider,
  GCashOrderFormProvider,
  SparklineProvider,
  MarketDataProvider,
  AlertProvider,
]);

// These Providers are used in Whitelabel Cypress Tests
export const CypressTestProviders = composeComponents([
  NotesProvider,
  WLWebSocketClientProvider,
  OrgConfigProvider,
  WLUserContextProvider,
  WLCustomerMarketAccountsProvider,
  WLCustomerUserConfigContextProvider,
  IntlProvider,
  CurrenciesProvider,
  SecuritiesProvider,
  WLOrdersProvider,
  GCashBalancesProvider,
  WLHomeCurrencyProvider,
  WLUsersContextProvider,
  CurrencyConversionProvider,
  WLExposuresProvider,
  WLTradingLimitsProvider,
  GCashHomeBalanceProvider,
  ProvidersGate,
  GCashQueryProvider,

  GCashBalanceTransactionProvider,

  GlobalDialogProvider,
  HeartbeatsProvider,
  GCashOrderFormProvider,
  StackScreenProvider,
  SparklineProvider,
  MarketDataProvider,
  AlertProvider,
]);
